<template>
  <b-modal ref="configModal" title="Tabelle Konfigurieren" @hide="onHide">
    <div>
      <b-form-checkbox :disabled="true" aria-checked="true" :checked="true">
        Dokument
      </b-form-checkbox>

      <draggable v-model="columnsCopy" handle=".handle">
        <div v-for="(column, index) in columnsCopy" :key="column.key" class="column-item" v-if="column.key != 'filename'">
          <i class="fas fa-bars handle mr-2" v-if="column.key != 'filename'"></i>
          <b-form-checkbox v-model="column.visible" :disabled="column.key == 'filename'">
            {{ column.label }}
          </b-form-checkbox>
        </div>
      </draggable>
    </div>
    <template #modal-footer>
      <b-button variant="secondary" @click="close">Abbrechen</b-button>
      <b-button variant="primary" @click="save">Speichern</b-button>
    </template>
  </b-modal>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'TableConfigModal',
  components: {
    draggable,
  },
  data() {
    return {
      columnsCopy: [],
    };
  },
  methods: {
    open(columns) {
      this.columnsCopy = JSON.parse(JSON.stringify(columns)); // Deep copy to prevent direct mutations
      this.$refs.configModal.show();
    },
    close() {
      this.$refs.configModal.hide();
    },
    save() {
      this.$emit('update-columns', this.columnsCopy);
      this.close();
    },
    onHide() {
      // Cleanup if necessary
    },
  },
};
</script>

<style scoped>
.column-item {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.handle {
  cursor: move;
}
</style>
